import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowchevron2RightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowchevron2_right_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M225.835 328.832a42.667 42.667 0 0 1 60.33-60.33L499.5 481.834a42.667 42.667 0 0 1 0 60.33L286.165 755.5a42.667 42.667 0 0 1-60.33-60.331L409.003 512 225.835 328.832zm358.997-60.33a42.667 42.667 0 1 0-60.33 60.33L707.668 512 524.501 695.168a42.667 42.667 0 0 0 60.331 60.33l213.333-213.333a42.667 42.667 0 0 0 0-60.33L584.832 268.5z"
    />
  </svg>
);
export default SvgArrowchevron2RightIcon;
